import React from "react"

export function Subcontractors(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 0C6.51602 0 6.125 0.391016 6.125 0.875V0.937891V3.66133C6.125 3.81445 6.00195 3.9375 5.84883 3.9375C5.75039 3.9375 5.65742 3.88555 5.6082 3.79805L4.2957 1.50391C2.26953 2.50195 0.875 4.58828 0.875 7V8.75H14.875V6.93438C14.8504 4.55 13.4613 2.49375 11.4543 1.50391L10.1418 3.79805C10.0926 3.88555 9.99961 3.9375 9.90117 3.9375C9.74805 3.9375 9.625 3.81445 9.625 3.66133V0.937891V0.875C9.625 0.391016 9.23398 0 8.75 0H7ZM0.453906 9.625C0.202344 9.625 0 9.82734 0 10.0789C0 10.2074 0.0546875 10.3305 0.158594 10.4043C0.751953 10.8391 3.05703 12.25 7.875 12.25C12.693 12.25 14.998 10.8391 15.5914 10.4043C15.6953 10.3277 15.75 10.2074 15.75 10.0789C15.75 9.82734 15.5477 9.625 15.2961 9.625H0.453906Z"
        fill="currectColor"
      />
    </svg>
  )
}
